import styled, { css } from 'styled-components';
import {
  backgroundShape,
  borderShape,
  getColor,
  getSpace,
  gridContainer,
  mq,
  px2rem,
  getTextType,
  setGridColumns,
  getGridColumns,
  getGridRows,
  getGridSpan,
  getGridSpans
} from '../../../stylesheets/tools';

const StyledEventTeaser = styled.div`
  ${props =>
    props.fullWidth
      ? css`
          width: 100%;
        `
      : css`
          margin-bottom: 60px;
          ${getGridSpans('width', {
            s: 12,
            m: 6
          })}
        `}
  ${props =>
    props.timeOnTop &&
    css`
      .eventTeaser__date {
        display: flex;
      }
      .eventTeaser__time-on-top {
        margin: 10px 0 0 30px;

        ${mq('m')} {
          margin: 10px 0 0 40px;
        }
      }
    `}
  ${props =>
    props.sliderItem
      ? css`
          padding: 15px;
          position: relative;
          background-color: transparent;
          background-image: linear-gradient(180deg, #000, #000), linear-gradient(225deg, #000, #000),
            linear-gradient(0deg, #000, #000), linear-gradient(90deg, #000, #000),
            linear-gradient(225deg, transparent 22px, #000 22px, #000 24px, transparent 24px);
          background-position: top left, top left, bottom right, bottom right, top right;
          background-size: calc(100% - 32px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 32px),
            40px 40px;
          background-repeat: no-repeat;

          &:before {
            clip-path: polygon(calc(100% - 32px) 0, 100% 32px, 100% 100%, 0 100%, 0 0);
            background-color: #fff;
            border: 2px solid;
            content: '';
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: -1;
            position: absolute;
          }

          .eventTeaser__categories {
            position: absolute;
            z-index: 1;
            left: 25px;
            top: 25px;

            .filterTags__tag {
              margin-left: unset;
              margin-right: 5px;
            }
          }

          .eventTeaser__time {
            color: #76797d;
          }

          h3 {
            font-size: 18px;
          }

          .eventTeaser__note {
            text-transform: uppercase;
            color: #76797d;
            display: block;
            margin-bottom: 10px;
            margin-top: 20px;
          }

          .eventTeaser__date {
            margin-top: -35px;
            margin-left: -30px;

            ${mq('m')} {
              margin-left: -40px;
            }
          }

          .eventTeaser__image {
            clip-path: polygon(calc(100% - 26px) 0, 100% 26px, 100% 100%, 0 100%, 0 0);

            img {
              aspect-ratio: 4 / 3;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .eventTeaser__link:after {
            position: absolute;
            content: '';
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
          }
          .eventTeaser__content {
            padding: 5px;
          }
        `
      : css`
      .eventTeaser__categories {
        flex-wrap: wrap;
        justify-content: flex-end;
        margin: 20px 0;

        div {
          margin-bottom: 5px;
        }

        div:last-of-type {
          margin-right: 0;
        }
      }

      .eventTeaser__link {
        ${gridContainer()}
        ${setGridColumns('1fr', 12, {
          m: ['1fr', 6]
        })}
        grid-gap: 10px;
        grid-row-gap: 0;
      }

      .eventTeaser__date {
        ${getGridSpans('left', { s: [-2, 'spread', 10], m: [-1, 'spread', 4] })};
        position: relative;

        ${mq('m')} {
          margin-left: 35px;
        }
      }

      .eventTeaser__content {
        ${getGridRows(3)}
        ${getGridColumns([3, 13], { m: [3, 6] })}
        margin-top: ${({ period }) => (period ? '40px' : '30px')};
        display: flex;

        ${mq('m')} {
          margin-left: -10px;
          margin-top: 30px;
        }
      }

      .eventTeaser__header {
        position: relative;
        ${getGridColumns([3, 13], { m: [1, 6] })}

        img {
          width: 100%;
          height: auto;
        }
      }
    `}

  ${props =>
    props.hasImage &&
    props.sliderItem === false &&
    css`
      .eventTeaser__image {
        background: ${getColor('lightGray')};
        animation: loadingBg 1s linear infinite alternate;
        padding-bottom: calc(3 / 4 * 100%);
        margin-bottom: -40px;
        height: 0;
      }
    `}
  .eventTeaser__copy {
    margin-top: ${getSpace('xs')};
  }
  .eventTeaser__icon {
    flex-shrink: 0;
    margin-right: ${getSpace('xxs')};
    fill: #000;
    color: ${props =>
      props.theme.siteTheme.primary !== '#fff' ? props.theme.siteTheme.primary : '#000'};
  }

  time {
    display: block;
    margin-bottom: 10px;
    margin-top: 20px;
  }

  .eventTeaser__spacer {
    display: block;
    margin-bottom: 10px;
    margin-top: 40px;
  }

  .eventTeaser__page-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding-right: 40px:
  }

  .eventTeaser__button-container {
    display: flex;
    width: 100%;
    text-transform: uppercase;
    margin-top: ${px2rem('20px')};

    a {
      width: 100%;
      text-align: center;
      ${getTextType('subline')};
      padding: ${px2rem('18px')} ${px2rem('22px')} ${px2rem('18px')} ${px2rem('25px')};

      ${borderShape()};
      &:hover {
        color: #fff;
        ${backgroundShape()};
      }
    }
  }


  .eventTeaser__button {
    justify-content: center;
    width: 100%;
    font-size: 16px;
  }

  ${props =>
    props.size === 's' &&
    props.sliderItem === false &&
    props.hasImage &&
    css`
      .eventTeaser__categories {
        margin-left: 10px;
        ${getGridColumns([3, 13], { m: [1, 6], l: [1, 6] })};
      }

      .eventTeaser__header {
        ${getGridColumns([3, 13], { m: [1, 6] })}
      }

      .eventTeaser__content {
        ${getGridColumns([3, 13], { m: [2, 6] })}
      }

      .eventTeaser__date {
        left: ${getGridSpan(-1, 'spread', 5)};
      }
    `}

  ${props =>
    !props.hasImage &&
    !props.hasImageFallback &&
    css`
      border: 1px solid #000;
      border-radius: 8px;
      margin-left: ${getGridSpan(1, 'spread')};

      ${getGridSpans('width', {
        s: 11,
        m: 4
      })}

      ${mq('m')} {
        margin-right: ${getGridSpan(1, 'spread')};
      }

      .eventTeaser__link {
        ${setGridColumns('1fr', 11, {
          m: ['1fr', 4]
        })}
      }

      .eventTeaser__header,
      .eventTeaser__content,
      .eventTeaser__categories {
        ${getGridColumns([1, 12], { m: [1, 5] })}
      }

      .eventTeaser__categories {
        ${getGridRows(1)}
        padding: 20px;
        margin: 0;
      }

      .eventTeaser__header {
        ${getGridRows(2)}
      }

      .eventTeaser__content {
        ${getGridRows(3)}
        padding: 20px;
        margin: 0;
        padding-top: ${({ period }) => (period ? '40px' : '20px')};

        ${mq('m')} {
          padding: 30px 40px 40px 40px;
        }
      }

      .eventTeaser__date {
        position: relative;
        bottom: auto;

        ${getGridSpans('left', {
          s: [-0.5, 'spread', 11],
          m: [-1, 'spread', 4]
        })}
      }
    `}

  ${props =>
    !props.hasImage &&
    !props.hasImageFallback &&
    props.size === 's' &&
    css`
      margin-right: 0;

      ${getGridSpans('width', {
        m: 5
      })}

      ${mq('m')} {
        margin-right: 0;
        .eventTeaser__link {
          ${setGridColumns(null, null, {
            m: ['1fr', 5]
          })}
        }
      }

      .eventTeaser__header,
      .eventTeaser__content,
      .eventTeaser__categories {
        ${getGridColumns(null, { m: [1, 6] })}
      }

      .eventTeaser__date {
        ${getGridSpans('left', {
          m: [-1, 'spread', 5]
        })}
      }
    `}
`;

export default StyledEventTeaser;
